<template>
  <v-app-bar app dark clipped-right color="primary">
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-row justify="space-between" align="center">
            <img
              src="../assets/enel_logo_white.png"
              :max-height="50"
              :height="40"
            />

            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <div v-on="on" class="d-flex align-center px-4 pointer">
                  <v-avatar :size="40">
                    <img :src="profilePicUrl" alt="avatar" />
                  </v-avatar>
                  <div class="ml-4 text-subtitle-2 font-weight-medium">
                    {{ name }}
                  </div>
                </div>
              </template>
              <v-list>
                <v-list-item @click="onEditProfile">
                  <v-list-item-title>Edit Profile</v-list-item-title>
                </v-list-item>
                <v-list-item @click="onLogout">
                  <v-list-item-title>Logout</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";

export default {
  name: "ProfileAppBar",
  computed: {
    ...mapFields("profile", {
      profilePicUrl: "profile.photo.url",
      name: "profile.name"
    })
  },
  methods: {
    ...mapActions("auth", {
      logoutUser: "logoutUser"
    }),

    ...mapActions("profile", ["setProfile"]),

    async onEditProfile() {
      this.$router.push({
        name: "profile"
      });
    },
    async onLogout() {
      try {
        await this.logoutUser();
      } finally {
        // logout user and route him to the
        // welcome screen
        this.$router.replace({
          name: "welcome"
        });

        this.setProfile(null);
      }
    }
  }
};
</script>
